import EfCardCartLists from './EFCardCartLists';
import EfSpec from '@elem/ui/ef-spec';
import { useState, useEffect } from 'react';
import styles from './index.module.scss';
import EfInfoSection from '@elem/ui/ef-info-section';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';
import { getSolarRecommand } from '@/service/solar-calculator';
import gtm from 'eco-design-reliance/gtm';
import useCardsShowHook from '../useHooks/useCardsShowHook';
import { useProductStore } from '../../../../ProductProvider';

export default function TheComp(props: any) {
    const { t } = useLang('Delta3AirSeries.C');
    const { locale } = useRouter();
    let { productPageData } = useProductStore();
    const items: any[] = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1763953727566/Frame%201612707810%20(2)%20(1).png',
            label: t('item1_label'),
            title: t('item1_title'),
            desc: t('item1_desc'),
            tab1: t('item1_tag1'),
            tab2: t('item1_tag2'),
            btnCartText: t('buy'),
            productId: '10394908557622',
            variantId: '53215190188342',
            quantity: 1,
        },
        {
            //写死
            img: 'https://websiteoss.ecoflow.com/upload/image/1763953664090/Frame%201612707810%20(1).png',
            label: t('item2_label'),
            title: t('item2_title'),
            desc: t('item2_desc'),
            tab1: t('item2_tag1'),
            tab2: t('item2_tag2'),
            // productId: '7213436534857',
            // variantId: '44505652854945',
            btnCartText: t('sold'),
            quantity: 1,
            inventory: 0,
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1763953727732/Frame%201612707810%20(3)%20(1).png',
            label: t('item3_label'),
            title: t('item3_title'),
            desc: t('item3_desc'),
            tab1: t('item3_tag1'),
            tab2: t('item3_tag2'),
            productId: '10394908557622',
            variantId: '53215190221110',
            btnCartText: t('coming'),
            quantity: 1,
            inventory: 0,
        },
    ];
    const [cards, setCards] = useState(JSON.parse(JSON.stringify(items)));

    const getAsynItem = async (item: any) => {
        const { variantId, productId } = item;
        return await new Promise(async (resolve, reject) => {
            try {
                const res = await getSolarRecommand({ productId, variantId }, locale);
                if (res?.code === '0') {
                    item.discountPrice = res?.data?.price ?? 0;
                    item.originalPrice = res?.data?.compareAtPrice ?? res?.data?.price ?? 0;
                    if (item.variantId !== '53215190221110') {
                        item.inventory = res?.data?.inventoryQuantity ?? 0;
                    }
                    // item.img = res?.data?.variantImg || res?.data?.img;
                    item.link_buy = `https://${locale}.ecoflow.com/cart/${item.variantId}:1?channel=buy_button`;
                    if ((res?.data?.inventoryQuantity <= 0 || !res?.data?.inventoryQuantity) && item.variantId !== '53215190221110') {
                        item.btnCartText = t('sold');
                    }
                    // if (res?.data?.productTitle || res?.data?.skuTitle) {
                    //     item.title = res?.data?.skuTitle || res?.data?.productTitle;
                    // }
                    return resolve(res);
                } else {
                    console.error(res?.message);
                    return reject(res?.message);
                }
            } catch (e) {
                console.error(e);
                return reject(e);
            }
        });
    };
    const getItemData = (data: any, card: any) => {
        const tempArr = JSON.parse(JSON.stringify(card));
        const productImages1 = data[0].images ? JSON.parse(data[0].images) : {};
        const productImages2 = data[1].images ? JSON.parse(data[1].images) : {};
        tempArr[0].img = productImages1?.transparentImages || productImages1?.spaceImages || productImages1?.images;
        tempArr[2].img = productImages2?.transparentImages || productImages2?.spaceImages || productImages2?.images;
        tempArr[0].title = data[0].name;
        tempArr[2].title = data[1].name;
        setCards(tempArr);
    };
    useEffect(() => {
        if (productPageData?.productSeries?.length) {
            const tempArr = JSON.parse(JSON.stringify(items));
            const promises = tempArr?.map((item: any) => item.variantId && getAsynItem(item));
            Promise.all(promises)
                .then(() => {
                    // setCards(tempArr);
                    // 图片和标题取cms配置
                    getItemData(productPageData?.productSeries, tempArr);
                })
                .catch((e) => {
                    console.error(e);
                });
        }
    }, [productPageData]);

    const callbackCart = (item: any, name: string) => {
        if (item?.inventory > 0) {
            window.open(item.link_buy, '_blank');
        }

        gtm.push({
            event: 'uaEvent',
            event_name: 'buy',
            position: 'https://ph.ecoflow.com/products/delta-3-air-series-portable-power-station',
            button_name: t('btnL'),
            __btn_id1: 'D3A-C .ef-card-cart-lists-card-add-cart',
            __btn_id2: item.link_buy,
            __btn_type: 'href',
        });
    };
    useCardsShowHook('.ef-card-cart-lists-cards-box .ef-card-cart-lists-card', '.ef-card-cart-lists-cards-box');
    return (
        <div className={`${styles.TheComp} D3A-C`}>
            <EfSpec />
            <EfInfoSection title={t('title')} />
            <EfCardCartLists items={cards} callbackCart={callbackCart} list_name={t('title')} />
            <EfSpec />
        </div>
    );
}
